<template>
  <div class="mb-4">
    <div class="d-flex mb-3" style="flex-wrap: wrap;">
      <b-button 
        v-for="(field, index) in cleanFields" 
        :key="index" 
        @click="updateChartData(field.key)"
        class="mr-2 mb-1"
        size="sm"
        :variant="field.key === selectedFieldKey ? 'outline-success':'outline-primary'"
        style="text-transform: none;"
      >
        {{ field.label || field.key }}
      </b-button>
    </div>

    <ColumnChart
      :height="500"
      :chartData="chartData"
      :options="chartOptions"
    ></ColumnChart>
  </div>
</template>

<script>
import ColumnChart from "@components/charts/ColumnChart.vue";

export default {
  components: {
    ColumnChart
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    allowedKeys: {
      type: Array,
      required: false,
      default: () => ["company.name", "company.inn", "source.name", "receive_datetime", "processing_end_datetime", "status.name", "close_reason.name", "selected_categories"]
    },
  },
  data() {
    return {
      selectedFieldKey: 'status.name',
      chartData: null,
      chartOptions: {
        scales: {
          yAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: false,
                min: 0,
              },
            },
          ],
          xAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: false,
                min: 1,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function(tooltipItem, data) {
              const label = data.labels[tooltipItem.index];
              const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return label + ': ' + value;
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      barColors: ['#40b590', '#ffed4a', '#4dc0b5', '#EA7B27', '#4dc0b5', '#6cb2eb', '#3490dc', '#9561e2']
    }
  },
  computed: {
    cleanFields() {
      return this.fields.filter(f => this.allowedKeys.includes(f.key));
    }
  },
  mounted() {
    this.generateChartData();
  },
  methods: {
    generateChartData() {
      const labels = this.fields.map(f => f.label || f);
      const datasets = [];

      // Assuming each item is an object with keys matching the field names
      this.items.forEach((item, index) => {
        const data = this.fields.map(f => item[f.key || f]);
        
        datasets.push({
          label: `Набор ${index + 1}`, // You might want to customize this label
          data
        });
      });

      this.chartData = { labels, datasets };

      if (!this.cleanFields.includes(this.selectedFieldKey)) {
        this.selectedFieldKey = this.cleanFields[0].key;
      }
      this.updateChartData(this.selectedFieldKey);
    },
    updateChartData(selectedFieldKey) {
      this.selectedFieldKey = selectedFieldKey;
      const labels = new Set();
      const dataMap = new Map();

      // Function to safely access nested fields
      const getValue = (item, path) => {
        return path.split('.').reduce((obj, key) => (obj && obj[key] !== undefined) ? obj[key] : null, item);
      };

      // Populate labels and initialize dataMap
      this.items.forEach(item => {
        let labelValue = getValue(item, selectedFieldKey);
        labelValue = labelValue !== null && labelValue !== undefined ? labelValue : 'Не задано';

        labels.add(labelValue);

        if (!dataMap.has(labelValue)) {
          dataMap.set(labelValue, 1); // Initialize with 1 instead of 0
        } else {
          dataMap.set(labelValue, dataMap.get(labelValue) + 1); // Increment existing count
        }
      });

      const sortedLabels = Array.from(labels).sort(); // Sort labels if needed
      const datasets = [{
        label: `Данные по ${selectedFieldKey}`,
        data: sortedLabels.map(label => dataMap.get(label)),
        backgroundColor: sortedLabels.map((_, index) => this.barColors[index % this.barColors.length])
      }];

      this.chartData = {
        labels: sortedLabels,
        datasets
      };
    }
  }
}
</script>
